var React = require('react');

function FbLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.6452 4.43361H14.1667V1.78387C13.9047 1.74807 13.0019 1.66669 11.9508 1.66669C9.75698 1.66669 8.25446 3.0469 8.25446 5.5827V7.91669H5.83337V10.8789H8.25446V18.3334H11.2216V10.8789H13.5449L13.9142 7.91669H11.2216V5.87567C11.2216 5.01955 11.4521 4.43361 12.6452 4.43361Z","fill":"#194CA9"}));
}

FbLogo.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = FbLogo;

FbLogo.default = FbLogo;
